<template>
  <div class="change-account">
    <span class="change-account-btn" @click="changeBox">切换账号</span>
    <div class="change-account-box" v-if="isShowBox">
      <div class="change-account-item"
        v-for="item in items"
        :key="item.userName"
        :class="{ 'active': activeItem && item.userName === activeItem.userName}"
        @click="selectItem(item)"
      >
        <span class="change-account-icon">
          <img :src="item.headerPic" />
        </span>
        <div class="change-account-info">
          <h5>{{item.nickName}}</h5>
          <p>{{item.userNameForShow}}</p>
        </div>
      </div>
      <span class="change-account-close" @click="changeBox">×</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-account',
  props: {
    items: { type: Array, default: () => [] },
    currentItem: { type: Object, default: () => null },
  },
  data() {
    return {
      isShowBox: false,
      activeItem: this.currentItem,
    };
  },
  methods: {
    changeBox() {
      this.isShowBox = !this.isShowBox;
    },
    selectItem(item) {
      this.activeItem = item;
      this.isShowBox = false;
      this.$emit('selectItem', item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.change-account {
  position: absolute;
  top: 10px;
  right: 0px;
  z-index: 9;
  &-btn {
    color: $mainColor;
    cursor: pointer;
    font-size: 14px;
  }
  &-box {
    position: absolute;
    z-index: 8;
    right: -134px;
    top: 42px;
    background-color: #fff;
    width: 550px;
    padding: 30px 40px 0;
    box-shadow:0px 2px 24px 0px rgba(0,0,0,0.12);
    border-radius: 8px;
    box-sizing: unset;
    &:after {
      display: block;
      content: '';
      visibility: visible;
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #fff;
      position: absolute;
      right: 142px;
      top: -10px;
    }
  }
  &-close {
    position: absolute;
    right: 4px;
    top: 4px;
    cursor: pointer;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color:#999;
    font-size: 20px;
  }
  &-item {
    @include flex;
    width: 226px;
    height: 58px;
    margin-bottom: 30px;
    padding: 10px 16px;
    background-color:rgba(248,248,248,1);
    border: 1px solid rgba(248,248,248,1);
    border-radius:4px;
    float: left;
    cursor: pointer;
    align-items: center;
    box-sizing: unset;
    &:nth-child(odd) {
      margin-right: 30px;
    }
    &.active {
      background-image: url('../imgs/account-sel@2x.png');
      border-color: $mainColor;
      background-repeat: no-repeat;
      background-position: right -1px bottom -1px;
      background-size: 28px auto;
    }
  }
  &-icon {
    float: left;
    width: 58px;
    height: 58px;
    border-radius: 58px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-info {
    margin-left: 10px;
    color:rgba(51,51,51,1);
    width: 160px;
    h5 {
      @include dot;
      margin: 0 0 6px 0;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
    }
    p {
      @include dot;
      margin: 0;
      font-size:14px;
      font-weight:400;
      line-height:20px;
    }
  }
}
</style>
